import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DivisionContextService } from '@app/core/services/division/division-context.service';
import { Observable } from 'rxjs';

@Injectable()
export class DivisionInterceptor implements HttpInterceptor {
  constructor(protected divisionContextService: DivisionContextService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('api')) {
      return next.handle(
        this.addDivisionHeader(this.divisionContextService.divisionFilter$.getValue().divisions, request)
      );
    } else {
      return next.handle(request);
    }
  }

  addDivisionHeader(divisions: string[], request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        'VfS-Division': JSON.stringify(this.divisionContextService.includeGlobalDivisions ? divisions : []),
        'VfS-Division-Enabled': JSON.stringify(this.divisionContextService.isEnabled())
      }
    });
  }
}
